import log from "./logger";

export const logApiCall = (method, url, data, response, error = null) => {
  log.debug(`API ${method} request to ${url}`, { data });
  if (error) {
    log.error(`API ${method} error for ${url}`, {
      status: error.response ? error.response.status : "Unknown",
      data: error.response ? error.response.data : "No response data",
      message: error.message,
    });
  } else {
    log.debug(`API ${method} response`, {
      status: response.status,
      data: response.data,
    });
  }

  const token = response?.config?.headers?.Authorization || "$TOKEN";
  const bashCommand = generateBashCurlCommand(method, url, data, token);
  const powershellCommand = generatePowershellCommand(method, url, data, token);

  log.debug("Bash curl command:", bashCommand);
  log.debug("PowerShell command:", powershellCommand);
};

const generateBashCurlCommand = (method, url, data, token) => {
  let command = `curl -X ${method.toUpperCase()} "${url}" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: ${token}"`;

  if (data) {
    command += ` \\\n  -d '${JSON.stringify(data)}'`;
  }

  return command;
};

const generatePowershellCommand = (method, url, data, token) => {
  let command = `Invoke-RestMethod -Uri '${url}' -Method ${method.toUpperCase()} -Headers @{'Content-Type'='application/json'; 'Authorization'='${token}'}`;

  if (data) {
    command += ` -Body '${JSON.stringify(data)}'`;
  }

  return command;
};
